import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { fetchFulfillmentOrderDetail, fetchFulfillmentWorkspaceEditor, listFulfillmentOrders } from "../repo";

/** 按行程只读查询确认件及指定供应商协议，不触发工作区创建或编辑器写入。 */
export function useFulfillmentOrderReadOnlyRuntime(itineraryId: string, enabled: boolean) {
  const [selectedOrder, setSelectedOrder] = useState<{ itineraryId: string; id: string } | null>(null);
  const workspaceLookup = useQuery({
    queryKey: ["fulfillmentOrder", "handoverWorkspace", itineraryId],
    queryFn: () => listFulfillmentOrders({
      itineraryId, page: 1, pageSize: 1, sortField: "updated_at", sortDirection: "desc",
    }),
    enabled: enabled && Boolean(itineraryId),
    retry: false,
    refetchOnWindowFocus: false,
  });
  const workspaceId = workspaceLookup.data?.items.find((item) => item.itineraryId === itineraryId)?.workspaceId;
  const workspace = useQuery({
    queryKey: ["fulfillmentOrder", "workspace", workspaceId],
    queryFn: () => fetchFulfillmentWorkspaceEditor(workspaceId!),
    enabled: enabled && Boolean(workspaceId),
    retry: false,
    refetchOnWindowFocus: false,
  });
  const selectedOrderId = selectedOrder?.itineraryId === itineraryId
    && workspace.data?.orders.some((order) => order.id === selectedOrder.id)
    ? selectedOrder.id : null;
  const detail = useQuery({
    queryKey: ["fulfillmentOrder", "detail", selectedOrderId],
    queryFn: () => fetchFulfillmentOrderDetail(selectedOrderId!),
    enabled: enabled && Boolean(selectedOrderId),
    retry: false,
    refetchOnWindowFocus: false,
  });
  return {
    workspace: enabled ? workspace.data : undefined,
    loading: workspaceLookup.isLoading || workspace.isLoading,
    error: workspaceLookup.error || workspace.error,
    retry: () => workspaceLookup.isError ? workspaceLookup.refetch() : workspace.refetch(),
    selectedOrderId,
    selectOrder: (id: string) => setSelectedOrder({ itineraryId, id }),
    closeDetail: () => setSelectedOrder(null),
    detail,
  };
}
